import React from 'react'
import { Button, Typography } from '@paintscout/ui'
import { useUserPermissions } from '@paintscout/ui-business'
import { useHistory } from 'react-router-dom'
import {
  DEACTIVATED_BODY_NO_PERMISSION,
  DEACTIVATED_BODY_WITH_PERMISSION,
  DEACTIVATED_BUTTON_LABEL,
  DEACTIVATED_HEADING
} from 'src/util/dunningCopy'
import classnames from 'classnames'
import StatCards from '../../shared/StatCards'
import { useDeactivatedDashboardStyles } from '../useDeactivatedDashboardStyles'
import { useTrialOverDashboardDesktopLayoutStyles } from '../../TrialOverDashboard/desktop/useTrialOverDashboardDesktopLayoutStyles'

/**
 * The deactivated block screen, desktop (ENG-1532).
 *
 * Reuses the trial-over layout and its four stat cards deliberately — the Figma block screen IS
 * that layout with different copy. A fourth parallel dashboard variant would be three files of
 * duplicated CSS for a screen nobody should see for long.
 */
export default function DeactivatedDashboardDesktop() {
  const classes = useTrialOverDashboardDesktopLayoutStyles()
  const own = useDeactivatedDashboardStyles()
  const { permissionToUpdateBilling } = useUserPermissions()
  const history = useHistory()

  return (
    <div className={classes.root}>
      <div className={classes.whiteBackground} />
      <div className={classes.leftSection}>
        <div className={classes.leftSectionContent}>
          <Typography className={classes.heading}>
            <span className={classes.headingFirstLine}>
              <span className={classes.headingHighlight}>{DEACTIVATED_HEADING}</span>
            </span>
          </Typography>
          <Typography className={own.body}>
            {permissionToUpdateBilling ? DEACTIVATED_BODY_WITH_PERMISSION : DEACTIVATED_BODY_NO_PERMISSION}
          </Typography>
          {permissionToUpdateBilling && (
            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={() => history.push('/settings?section=billing-plan')}
              className={classnames(classes.button, own.button)}
            >
              {DEACTIVATED_BUTTON_LABEL}
            </Button>
          )}
        </div>
      </div>
      <div className={classes.rightSection}>
        <StatCards classes={classes} />
      </div>
    </div>
  )
}
